// Global Instructions Rule Applied!
// Standalone route wrapper for the Capital Call Position view
// (/capital-call-position): fund selector enabled. The Fund form's Capital
// Calls tab embeds the same component with the fund fixed.
import React from 'react'
import CallPositionView from './CallPositionView.tsx'

export default function CallPositionPage() {
  return <CallPositionView />
}
